<template>
  <div>
    <commonMenu v-show="isshow&&isNotInApp"></commonMenu>
    <header>
      <ul>
        <li>
          <img class="img_back" src="../../assets/myicon/return1.png" alt @click="goBack">
        </li>
        <p class="li2">报考</p>
        <li>
          <img
            v-show="isNotInApp"
            class="img_menu"
            src="../../assets/myicon/mores.png"
            @click="clicks"
          >
        </li>
      </ul>
    </header>
    <van-tabs v-model="active" @click="onClick">
      <van-tab style="width:100vw;" title="报名考试">
        <div v-for="(item,index) in testlist" :key="index" class="all_erda">
          <div class="erda">
            <div class="erxiao">
              <p class="p1">{{ item.test_name }}</p>
              <p class="p2">
                <span>发证单位</span>
                <span>{{ item.certification_unit_name }}</span>
              </p>
              <p>
                <span style="color:#ee2e2e;padding-left:1px;">{{ item.test_count?item.test_count:0 }}人已报考</span>
              </p>
            </div>
            <div class="btns">
              <div></div>
              <div>
                <button
                  v-show="item.consultUrl"
                  class="btn_zx"
                  @click="pintuan(item.id,item.consultUrl)"
                >咨询</button>
                <button v-if="item.status==0" class="btn_bm" @click="baoming(item.id,item.registration_cost,item.status)">报名</button>
                <button v-else-if="item.status==1" class="btn_bm" @click="baoming(item.id,item.registration_cost,item.status)">未支付</button>
                <button v-else-if="item.status==2" class="btn_bm" @click="baoming(item.id,item.registration_cost,item.status)">待审核</button>
                <button v-else-if="item.status==3" class="btn_bm" @click="baoming(item.id,item.registration_cost,item.status)">通过</button>
                <button v-else-if="item.status==4" class="btn_bm" @click="baoming(item.id,item.registration_cost,item.status)">未通过</button>
                <button v-else class="btn_bm" @click="baoming(item.id,item.registration_cost)">报考成功</button>
                <button v-if="item.order_sn && item.status==3" class="btn_bm" @click="makeInvoice(item)">开发票</button>
              </div>

            </div>
          </div>
        </div>
      </van-tab>

      <van-tab title="成绩查询" class="chengji">
        <div v-for="(item, index) in chengjilist" :key="index" class="cheng_item">
          <div class="item_info">
            <div class="item_left">
              <p class="item_title">{{ item.test_name }}</p>
              <p class="item_type">{{ item.type_name }}</p>
              <p class="item_time">{{ item.day }}</p>
            </div>
            <div class="item_right">
              <p>
                {{ parseInt(item.score) }}
                <span>分</span>
              </p>
            </div>
          </div>
          <div>
            <el-button v-if="item.certificate_no && item.certificate_no.length > 0" type="text" size="mini" style="margin: 10px 10px 0 0;color:#ee2e2e;" @click="lookCertificate(item)">查看证书</el-button>
            <el-button v-if="agency_id == 398 && item.is_xszm == 0 && item.open_apply == 1" type="text" size="mini" style="margin: 0 10px 0 0;color:#ee2e2e;" @click="applyStudyTime(item)">申请证明</el-button>
            <span v-if="agency_id == 398 && item.is_xszm == 1" style="color: #999;">已申请</span>
          </div>
        </div>
      </van-tab>
      <div v-if="(active==0&&testlist.length==0) || (active==1&&chengjilist.length==0)" class="noComment">
        <div class="no_img">
          <img src="https://newoss.zhulong.com/forum/202306/14/15/1686728350641932.png" alt="">
        </div>
        <div class="no_text">暂无内容~</div>
      </div>
    </van-tabs>
  </div>
</template>

<script>
import { chengjilist, test_list } from '@/api/examination.js'
import commonMenu from '@/components/common/menu'
// import Curse from './Curse.vue'
import tool from '@/utils/tools.js'
import Cookies from 'js-cookie'


export default {
  components: { commonMenu },
  data() {
    return {
      agency_id: Cookies.get('agency_id') || '',
      active: 0,
      page: 1,
      limit: 10,
      count: 0,
      lesson_id: this.$route.query.lesson_id ? this.$route.query.lesson_id : '',
      type_id: 0,
      activeName: '1',
      chengjilist: [],
      msg: '',
      testlist: [],
      isshow: false,
      isNotInApp: true
    }
  },
  created() {
    this.cheng_jilist()
    this.get_textlist()
  },
  mounted() {
    const hrefUrl = window.location.href
    if (hrefUrl.indexOf('score') != -1) {
      this.active = 1
    } else {
      this.active = 0
    }
    if (tool.isInApp()) {
      this.isNotInApp = false
    } else {
      this.isNotInApp = true
    }
  },
  methods: {
    clicks() {
      if (this.isshow == false) {
        this.isshow = true
      } else {
        this.isshow = false
      }
    },
    goBack() {
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_backApp.postMessage('app')
        } else {
          window.WebViewJavascriptBridge.callHandler(
            'vue_backApp'
            , '报考返回'
            , function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
        this.$router.go(-1)
      }
    },
    get_textlist() {
      const data = {
        page: this.page,
        limit: this.limit,
        lesson_id: this.lesson_id,
        type_id: this.type_id,
        time_type: this.activeName
      }
      test_list(data).then(res => {
        console.log(res)
        this.testlist = res.result.list
      })
    },
    cheng_jilist() {
      chengjilist().then((res) => {
        console.log(res)
        this.chengjilist = res.result
      })
    },
    makeInvoice(row) {
      const url = `${window.location.origin}/ucenter/makeInvoice?order_id=${row.orders_id}&order_sn=${row.order_sn}`
      window.location.href = url
    },
    baoming(ids, money, status) {
      if (status == 0 || status == 1) {
        this.$router.push({
          path: '/applyinfo',
          query: {
            id: ids
          // money: money
          }
        })
      } else {
        this.$router.push({
          path: '/applyinfo',
          query: {
            id: ids,
            my_index: 3
          }
        })
      }
    },
    pintuan(id, url) {
      // this.$router.push({
      //   path: '/group_work',
      //   query: {
      //     id: id
      //   }
      // })
      window.location.href = url
    },
    onClick(name, title) {
      if (name == 0) {
        this.$router.push({
          path: '/test'
        })
      } else {
        this.$router.push({
          path: '/score'
        })
      }
    },
    // 查看证书
    lookCertificate(val) {
      const host = window.location.origin
      const url = `${host}/edu/prod-api/personal/certification/downCertification?type=look&id=${val.id}&source=3`
      window.open(url)
    },
    // 申请学时 agency_id = 398
    applyStudyTime(val) {
      const host = window.location.origin
      const url = `${host}/shop/pay?product_type=18&product_id=${val.exam_id}&fromurl=`
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>

.all_erda {
  width: 100%;
  border-bottom: 1px solid rgb(241, 235, 235);
}
.p3 {
  color: rgb(161, 161, 161);
  padding-top: 19px;
}
.left {
  width: 72%;
  p:nth-child(1) {
    padding-left: 42px;
  }
  p:nth-child(2) {
    padding-left: 42px;
  }
  p:nth-child(3) {
    padding-left: 42px;
  }
}
.right {
  width: 160px;
  height: 160px;
  // background: red;
  line-height: 160px;
  text-align: center;
  margin-top: 20px;
  font-size: 40px;
  border-radius: 100px;
  color: rgb(161, 161, 161);
}
.right1 {
  width: 107px;
  height: 107px;
  background: #f4f4f4;
  border-radius: 50%;
  color: rgb(238, 46, 46);
  position: absolute;
  right: 39px;
  top: 36px;
  p {
    text-align: center;
    line-height: 107px;
    font-size: 35px;
    font-weight: 600;
    span {
      font-size: 20px;
      padding-left: 2px;
      font-weight: 500;
    }
  }
}
.cheng {
  width: 96%;
  height: 200px;
  border-bottom: 1px solid rgb(241, 235, 235);
  display: flex;
  margin: 0 auto;
}
.cheng_item {
  padding: 30px 30px 20px;
  border-bottom: 1px solid rgb(241, 235, 235);
  .item_info {
    display: flex;
    flex-direction: row;
    align-items: center;
    .item_left {
      width: calc(100% - 120px);
      .item_title {
        font-size: 34px;
      }
      .item_type {
        margin: 15px 0;
        font-size: 26px;
      }
      .item_time {
        color: rgb(161, 161, 161);
      }
    }

    .item_right {
      margin-left: 10px;
      width: 110px;
      height: 110px;
      background: #f4f4f4;
      border-radius: 50%;
      color: rgb(238, 46, 46);
      p {
        text-align: center;
        line-height: 110px;
        font-size: 35px;
        font-weight: 600;
        span {
          font-size: 20px;
          padding-left: 2px;
          font-weight: 500;
        }
      }
    }
  }
}

.cheng1 {
  display: flex;
  margin: 0 auto;
  position: relative;
}
.hui {
  width: 100%;
  height: 15px;
  background: rgb(245, 245, 245);
}
.btns {
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  div{
    margin-right: 20px;
  }
  .btn_bm {
    font-size: 30px;
    width: 116px;
    height: 56px;
    text-align: center;
    line-height: 59px;
    border: none;
    background: #ee2e2e;
    border-radius: 50px;
    margin-top: 30px;
    color: #fff;
    margin-left: 20px;
  }
  .btn_zx {
    font-size: 30px;
    width: 116px;
    height: 56px;

    text-align: center;
    line-height: 54px;
    border: 1px solid #ee2e2e;
    background-color: #fff;
    color: #ee2e2e;
    border-radius: 50px;
    margin-top: 30px;
  }
}
/deep/ .van-tabs__wrap{
  border-bottom: 2px solid #eeeeee;
}
.erxiao {
  width: 96%;
  height: 180px;
  margin: 0 auto;
}
.p1 {
  width: 100%;
  height: 90px;
  line-height: 90px;
  font-size: 32px;
  padding-top: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.p11 {
  width: 80%;
  font-size: 34px;
  // font-weight: 600;
  padding-top: 41px;
}
.p2 {
  width: 100%;
  min-height: 60px;
  line-height: 40px;
  font-size: 26px;
  span:nth-child(1) {
    margin-left: 0px;
    color: rgb(161, 161, 161);
  }
  span:nth-child(2) {
    margin-left: 16px;
    color: rgb(161, 161, 161);
  }
  span:nth-child(3) {
    margin-left: 16px;
    color: red;
  }
}
.p22 {
  width: 80%;
  font-size: 26px;
  color: rgb(161, 161, 161);
  padding-top: 20px;
}
.erda {
  width: 96%;
  // background: rgb(165, 137, 86);
  height: 306px;
  margin: 0 auto;
  // border-bottom: 1px solid rgb(241, 235, 235);
}
.erda::after {
  width: 100%;
  height: 2px;
  border-bottom: 3px solid #ccc;
  content: "  ";
}
.li2 {
  width: 600px;
  padding-right: 50px;
}
header {
  width: 100%;
  height: 110px;
  background: rgb(255, 255, 255);
  border-bottom: 1px solid rgb(241, 235, 235);
  ul {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: rgb(0, 0, 0);
    font-size: 40px;
    text-align: center;
    li {
      height: 120px;
      line-height: 120px;
      display: flex;
      align-items: center;
    }
  }
  .img_menu{
    width: 40px;
    height: 36px;
    margin-right: 24px;
  }
  .img_back{
    width: 70px;
    height: 70px;
    margin-left: 24px;
  }
}
.noComment{
  .no_img{
    img{
      margin: 200px auto 0;
      display: block;
    }
  }
  .no_text{
    text-align: center;
    color: #999;
  }
}
</style>
<style lang="scss">
.van-tabs__wrap {
  // width: 50%;
  margin: auto;
}
</style>
